const stats = [
  { value: "iOS", label: "Platform Focus" },
  { value: "100%", label: "Quality Commitment" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-[#0a0a0a] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Label */}
        <p className="text-[#C9A85C] text-xs tracking-[5px] uppercase font-medium mb-6">
          About Our Expertise
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: Text */}
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-8">
              A team of{" "}
              <span className="relative inline-block">
                experts
                <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-gradient-to-r from-[#C9A85C] to-transparent" />
              </span>
              <br />
              building modern
              <br />
              iOS applications.
            </h2>
            <div className="space-y-5 text-white/60 text-base leading-relaxed">
              <p>
                KOMAS DOO was founded with a singular focus — to build
                exceptional applications for the iOS platform that genuinely
                improve people&apos;s digital lives. Our team brings deep
                technical expertise and a passion for clean, purposeful design.
              </p>
              <p>
                We believe that security and performance should never be
                compromised. Every product we ship goes through rigorous testing
                and refinement to ensure it meets the highest standards of
                reliability and user experience.
              </p>
              <p>
                Based in Valjevo, Serbia, our team operates with global
                standards and a commitment to continuous innovation in the iOS
                ecosystem.
              </p>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="w-full h-[480px] rounded-3xl overflow-hidden border border-white/5">
              <img
                src="https://public.readdy.ai/ai/img_res/a0593900235dcebd27ad8c2e3c1c45ee.jpg"
                alt="KOMAS DOO development workspace"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/60 to-transparent rounded-3xl" />
            </div>
            {/* Decorative corner accent */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-[#C9A85C]/30 rounded-tr-2xl" />
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-[#C9A85C]/30 rounded-bl-2xl" />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-6 mt-20 max-w-2xl mx-auto w-full">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white/[0.03] border border-white/[0.06] rounded-2xl p-8 text-center hover:bg-white/[0.05] transition-colors duration-300"
            >
              <p className="text-5xl font-bold text-[#C9A85C] mb-3">{stat.value}</p>
              <p className="text-white/50 text-sm tracking-wider uppercase">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
